/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fast_Warm_Bull_FeedInputs */

const en_fast_warm_bull_feed = /** @type {(inputs: Fast_Warm_Bull_FeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profile`)
};

const de_fast_warm_bull_feed = /** @type {(inputs: Fast_Warm_Bull_FeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil`)
};

/**
* | output |
* | --- |
* | "Profile" |
*
* @param {Fast_Warm_Bull_FeedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fast_warm_bull_feed = /** @type {((inputs?: Fast_Warm_Bull_FeedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fast_Warm_Bull_FeedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fast_warm_bull_feed(inputs)
	return de_fast_warm_bull_feed(inputs)
});